import { useInstantSearch } from 'react-instantsearch';

export default function useCurrentSortOrder() {
  const { uiState } = useInstantSearch();
  //If no sort order set, return index name
  return uiState[Object.keys(uiState)[0]].sortBy || Object.keys(uiState)[0];
}
